import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export default function ProtectedRoutes({ allowedRoles }) {
    const [role, setRole] = useState(null);

    useEffect(() => {
        try {
            const storedUser = JSON.parse(localStorage.getItem('user'));
            setRole(storedUser?.role || 'public');
        } catch {
            setRole('public');
        }
    }, []);

    if (role === null) return <div>Chargement...</div>;

    return allowedRoles.includes(role) ? <Outlet /> : <Navigate to="/login" replace />;
}
